export default function WhyChooseUsSection() {
  const reasons = [
    {
      icon: 'ri-hand-coin-fill',
      title: 'All-Cash Offers',
      description: 'We make competitive cash offers on tenant occupied real estate. No financing contingencies, no waiting for bank approvals. We have the funds ready to close quickly.'
    },
    {
      icon: 'ri-user-follow-fill',
      title: 'Keep Tenants in Place',
      description: 'Your tenants can stay during and after the sale. We buy rental property with existing lease agreements intact, minimizing disruption for everyone involved.'
    },
    {
      icon: 'ri-shield-check-fill',
      title: 'Title Company Protection',
      description: 'Every transaction is processed through a reputable title company. This ensures proper documentation, legal compliance, and complete protection for all parties.'
    },
    {
      icon: 'ri-time-fill',
      title: 'Fast Closings',
      description: 'We can close in as little as 7-14 days. When you sell tenant occupied property to us, you avoid the 6-12 month timeline of traditional sales.'
    },
    {
      icon: 'ri-tools-fill',
      title: 'Buy As-Is Condition',
      description: 'No repairs, no renovations, no maintenance required. We buy rental property in any condition—even if it needs significant work or has deferred maintenance.'
    },
    {
      icon: 'ri-file-list-3-fill',
      title: 'Handle All Paperwork',
      description: 'We manage all documentation, lease transfers, tenant notifications, and legal requirements. You simply sign at closing and receive your payment.'
    },
    {
      icon: 'ri-money-dollar-circle-fill',
      title: 'No Commissions or Fees',
      description: 'When you sell with tenants to us, there are no real estate commissions, no listing fees, no closing costs. The offer we make is what you receive.'
    },
    {
      icon: 'ri-award-fill',
      title: 'Proven Track Record',
      description: 'With 200+ rental properties purchased and $120M+ in transactions, we have the experience and credibility to handle any tenant occupied property situation.'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Why Sell Your Tenant Occupied Property to Us?
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            We specialize in buying rental property with tenants in place. Here's what makes us the preferred choice for landlords throughout El Paso, Texas.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {reasons.map((reason, index) => (
            <div 
              key={index}
              className="bg-white p-8 rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2"
            >
              <div className="w-16 h-16 bg-teal-100 rounded-lg flex items-center justify-center mb-6">
                <i className={`${reason.icon} text-teal-600 text-3xl`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">{reason.title}</h3>
              <p className="text-gray-600 leading-relaxed">{reason.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <a 
            href="tel:+1-915-206-5814"
            className="inline-flex items-center bg-teal-600 hover:bg-teal-700 text-white px-8 py-4 rounded-lg text-lg font-bold transition-all transform hover:scale-105 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-phone-fill mr-2"></i>
            Call (915) 206-5814 for Your Cash Offer
          </a>
        </div>
      </div>
    </section>
  );
}